"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DoubleCross_exports = {};
__export(DoubleCross_exports, {
  default: () => DoubleCross_default
});
module.exports = __toCommonJS(DoubleCross_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.72656 15.0938C2.63542 14.9896 2.58984 14.8724 2.58984 14.7422C2.58984 14.599 2.63542 14.4818 2.72656 14.3906L6.78906 10.3281L2.72656 6.26562C2.63542 6.17448 2.58984 6.0638 2.58984 5.93359C2.58984 5.79036 2.63542 5.66667 2.72656 5.5625C2.83073 5.47135 2.94792 5.42578 3.07812 5.42578C3.22135 5.42578 3.33854 5.47135 3.42969 5.5625L7.49219 9.625L11.5547 5.5625C11.6458 5.47135 11.763 5.42578 11.9062 5.42578C12.0495 5.42578 12.1667 5.47135 12.2578 5.5625C12.362 5.66667 12.4141 5.79036 12.4141 5.93359C12.4141 6.0638 12.362 6.17448 12.2578 6.26562L8.19531 10.3281L12.2578 14.3906C12.362 14.4818 12.4141 14.599 12.4141 14.7422C12.4141 14.8724 12.362 14.9896 12.2578 15.0938C12.1667 15.1849 12.0495 15.2305 11.9062 15.2305C11.763 15.2305 11.6458 15.1849 11.5547 15.0938L7.49219 11.0312L3.42969 15.0938C3.33854 15.1849 3.22135 15.2305 3.07812 15.2305C2.94792 15.2305 2.83073 15.1849 2.72656 15.0938ZM11.2031 11.9688L12.8047 10.3086L11.2031 8.70703L11.9062 8.00391L13.5078 9.60547L17.4531 5.5625C17.5443 5.47135 17.6615 5.42578 17.8047 5.42578C17.9479 5.41276 18.0651 5.45833 18.1562 5.5625C18.2604 5.65365 18.3125 5.77083 18.3125 5.91406C18.3125 6.04427 18.2669 6.16146 18.1758 6.26562L14.2109 10.3086L18.2734 14.3906C18.3646 14.4948 18.4102 14.6185 18.4102 14.7617C18.4102 14.8919 18.3646 15.0091 18.2734 15.1133C18.1693 15.2044 18.0456 15.25 17.9023 15.25C17.7721 15.25 17.6615 15.1979 17.5703 15.0938L13.5078 11.0312L11.9062 12.6523L11.2031 11.9688Z",
      fill: "currentColor"
    }
  )
);
const SvgDoubleCross = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DoubleCross_default = SvgDoubleCross;
